export enum ShipType {
    Motorboat = 'Motorboat',
    Sailboat = 'Sailboat',
    JetSki = 'JetSki',
    InflatableBoat = 'InflatableBoat',
    Yacht = 'Yacht',
    Catamaran = 'Catamaran',
    Schooner = 'Schooner',
    Trawler = 'Trawler',
    Kayak = 'Kayak',
    Canoe = 'Canoe',
    WaveBoat = 'WaveBoat'

  }
